<template>
    <ui-stats-chart fill
        v-bind:series="series"
        v-bind:y-format="axisFormat"
        v-bind:loading="!points.length"/>
</template>

<script>
import UiStatsChart from '~/components/stats/UiStatsChart.vue';
import { formatFiat } from '~/components/stats/statsFormat.js';

/**
 * Price chart of a token (or an LP pool asset): the stats-page SVG chart
 * over the points the parent has loaded. The points come as
 * [{ timestamp (ms), value }]; an empty list draws the skeleton.
 */
export default {
    props: {
        chartData: {
            type: Array,
            required: true,
            default: () => [],
        },
        // Currency code of the values, USD unless the parent loaded another one:
        currency: {
            type: String,
            default: 'USD',
        },
    },

    computed: {
        points() {
            if (!Array.isArray(this.chartData)) {
                return [];
            }
            return this.chartData
                .map(({ timestamp, value }) => ({ t: Number(timestamp), v: Number(value) }))
                .filter(point => Number.isFinite(point.t) && Number.isFinite(point.v))
                .sort((a, b) => a.t - b.t);
        },

        series() {
            if (!this.points.length) {
                return [];
            }
            return [{
                key: 'price',
                label: this.$t('jetton.price'),
                color: 'var(--blue-bright)',
                type: 'area',
                data: this.points,
                format: (value, locale) => formatFiat(value, locale, this.currency),
            }];
        },
    },

    methods: {
        axisFormat(value, locale, digits) {
            return formatFiat(value, locale, this.currency, digits);
        },
    },

    components: {
        UiStatsChart,
    },
};
</script>

<style lang="scss">
.jetton-chart-container {
    display: flex;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    min-height: 220px;
    padding: 0 14px 12px 0;
}

// The period switcher above the chart on a phone and a tablet:
.jetton-chart__switcher {
    display: flex;
    justify-content: flex-end;
    margin: 10px 0;
    padding: 0 16px;
}

@media screen and (max-width: 991px) {
    .jetton-chart-container {
        height: 220px;
        min-height: 0;
        padding: 0 16px 4px;
    }
}
</style>
